import { useState, useEffect } from 'react';

export default function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const taskId = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(taskId);
  }, [value, delay]);

  return debouncedValue;
}
